import React from "react";
import { MenuItem, Spinner } from "@chakra-ui/react";
import { IoArrowUndoOutline } from "react-icons/io5";
import { getUserTimezone, useToast } from "duck";
import { useExportMedicalCaseToVetspireMutation } from "requests";

interface VetspireExportProps {
  handleClose(): void;
  isVetspireCase: boolean;
  caseId: number;
}

const VetspireExport: React.FC<VetspireExportProps> = ({
  handleClose,
  isVetspireCase,
  caseId
}) => {
  const [
    exportToVetspire,
    { loading }
  ] = useExportMedicalCaseToVetspireMutation({
    variables: {
      input: {
        medicalCase: caseId,
        userTimezone: getUserTimezone()
      }
    }
  });
  const toast = useToast({ status: "success" });

  const handleExport = () => {
    exportToVetspire().then(() => {
      toast({
        description: "Case data is exported to EMR successfully."
      });
      handleClose();
    });
  };

  return (
    <MenuItem
      icon={
        loading ? (
          <Spinner width="12px" height="12px" />
        ) : (
          <IoArrowUndoOutline size="12px" />
        )
      }
      fontSize="sm"
      isDisabled={!isVetspireCase}
      onClick={handleExport}
    >
      Case to PIMS
    </MenuItem>
  );
};

export default VetspireExport;
